module.exports = __webpack_public_path__ + "static/img/img(22).6daeb4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(22).png
// module id = y2ku
// module chunks = 1